module.exports = __webpack_public_path__ + "static/img/labourservices-9.3fd6209.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/rescuelist/img/list/labourservices-9.png
// module id = TxjZ
// module chunks = 1